import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Loader from '../../../../../../components/Loaders/Loader';
import { SubscriptionsMainContext } from '../../../index';

import { changeExpirySuccess, modalClose } from '../../../reducer';
import { getErrorMessage } from '../../../../../../utils/helper';
import {
  subscriptionsExpiryDate,
} from '../../../../../../services/endpoints/subscriptions';
import ModalPreloader from '../../../../../../components/Modal/Preloader';
import DatePicker from '../../../../../../components/DatePickers/Date';

const ModalEditExpiry = () => {
  const [store, dispatch] = useContext(SubscriptionsMainContext);
  const { modal } = store;

  const minDate = new Date().toISOString().substr(0, 10);

  const [form, setForm] = useState({
    isLoading: false,
    error: null,
    success: false,
    subscriptionId: null,
    expiry: minDate,
  });
  const { isLoading, init, subscriptionId, error, expiry } = form;

  useEffect(() => {
    setForm((prevState) => ({
      ...prevState,
      isLoading: false,
      init: true,
      subscriptionId: modal.data.id,
      expiry: modal.data.expiry,
      error: null,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onCloseModal = () => {
    dispatch(modalClose())
  }

  const onChangeExpiryDate = (fieldName, newDate) => {
    setForm((prevState) => ({
      ...prevState,
      expiry: newDate,
    }))
  }

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      setForm((prevState) => ({
        ...prevState,
        error: null,
        isLoading: true,
      }));
      const response = await subscriptionsExpiryDate(subscriptionId, expiry)
      if (response) {
        await setForm((prevState) => ({
          ...prevState,
          success: true,
        }));
        dispatch(changeExpirySuccess())
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setForm((prevState) => ({
        ...prevState,
        isLoading: false,
        error: errorMessage,
      }));
    }
  }

  return (
    <div>
      <Modal.Header closeButton={!isLoading && init}>
        <Modal.Title>Edit expiry</Modal.Title>
      </Modal.Header>
      <ModalPreloader
        isLoading={!init}
      >
        <form onSubmit={onSubmit}>
          <Modal.Body>
            {isLoading ? <Loader success={form.success} /> : null }
            {error ? <div className="alert alert-danger">{error}</div> : null}
            {init
              ? (
                <div>
                  <DatePicker
                    defaultDate={minDate}
                    value={expiry}
                    minDate={minDate}
                    id="expiry_date"
                    fieldName="expiry_date"
                    setFieldValue={onChangeExpiryDate}
                  />
                </div>
              ) : null}
          </Modal.Body>
          <Modal.Footer className="custom__modal-footer">
            <Button disabled={isLoading} bsStyle="primary" type="submit">
              Save changes
            </Button>
            <Button
              disabled={isLoading}
              onClick={onCloseModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </form>
      </ModalPreloader>
    </div>
  )
};

ModalEditExpiry.propTypes = {

};

export default ModalEditExpiry;
